import { FC } from "react";
import { useField } from 'formik';
import { IBaseField } from "./BaseField";
import { Mask } from "src/Controls";

interface IMaskFieldProps extends IBaseField {
	/** Маска ввода */
	mask?: string;
	/** Словарь форматов для пользовательских масок */
	formatChars?: Record<string, string>;
	/** Символ заполнитель */
	maskChar?: string | null;
	/** Флаг фокуса */
	autoFocus?: boolean;
};

/**
 * Текстовое поле с маской
 */
const MaskField: FC<IMaskFieldProps> = ( props ) => {

	const { name, autoFocus, ...otherProps } = props;
	const [ inputProps, meta ] = useField( name );

	return (
		<Mask
			{...otherProps}
			{...inputProps}
			{...meta}
			autoFocus={autoFocus}
		/>
	);
};

export default MaskField;
